<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="分销启用：" prop="distributionStatus">
        <el-radio-group v-model="ruleForm.distributionStatus">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="分销海报：" prop="distributionPosterImg">
        <upload-img :fileList="distributionPosterImgList" warmTxt="建议尺寸：670*1028px，最多一张，若需要更换图片，请先删除原图片" @imgUrlBtn="imgUrlBtn"></upload-img>
      </el-form-item>
      <el-form-item label="佣金提现说明：" prop="distributionDesc">
        <editor :value="ruleForm.distributionDesc" :height="350" v-model="ruleForm.distributionDesc"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
export default {
  name: 'Distribution',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      ruleForm: {
        distributionStatus:'',
        distributionPosterImg:'',
        distributionDesc:""
      },
      distributionPosterImgList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    var that = this;
    fetchShopConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        if(data.distributionPosterImg != '' && data.distributionPosterImg != null){
          that.distributionPosterImgList.push({url: data.distributionPosterImg})
        }
        that.ruleForm.distributionStatus = data.distributionStatus
        that.ruleForm.distributionDesc = data.distributionDesc
      }
    })
  },
  methods: {
    imgUrlBtn(backData){
       // 图片
        this.ruleForm.distributionPosterImg = backData.imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let distributionPosterImg = that.ruleForm.distributionPosterImg
      let distributionStatus = that.ruleForm.distributionStatus
      let distributionDesc = that.ruleForm.distributionDesc
      that.fullscreenLoading = true
      saveOrUpdateShopConfig({distributionPosterImg:distributionPosterImg,distributionStatus:distributionStatus,distributionDesc:distributionDesc}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              // that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/Distribution.vue